module.exports = __webpack_public_path__ + "img/signpost-2-fill.eec5d080.svg";